import { Category } from './category';

export namespace CategoryParsers {
  export type CategoryJson = {
    id: number;
    name: string;
    slug?: string;
    description?: string;
    isFeatured: boolean;
    isActive: boolean;
    isDeleted: boolean;
    requiresLicense: boolean;
    parent?: number;
    children: number[];
    topText?: string;
    bottomText?: string;
  };

  export function toCategory(input: CategoryJson): Category {
    return input;
  }
}
